import { isEmpty } from 'lodash';
import React, { ReactElement } from 'react';
import { RefreshInfoCardProps } from '../../../shared/interfaces/reportingAndAnalyticsInterface';
import { getDateWithTime } from '../../../utils/dateTimeUtils';
import { REPORTING_CONSTANTS } from './reportingAndAnalyticsConstants';

const RefreshInfoCard: React.FC<RefreshInfoCardProps> = ({
  dataAvailableFrom,
  lastRefreshedOn,
  refreshFrequency,
}: RefreshInfoCardProps): ReactElement => {
  return !isEmpty(dataAvailableFrom) ? (
    <div className="refresh-info-card">
      <span className="refreshed-key">
        {REPORTING_CONSTANTS.DATA_AVAILABLE_FROM} <br />
        <span className="refreshed-value">
          {getDateWithTime(dataAvailableFrom)}
        </span>
      </span>
      <br />
      <span className="refreshed-key">
        {REPORTING_CONSTANTS.LAST_REFRESHED_ON} <br />
        <span className="refreshed-value">
          {getDateWithTime(lastRefreshedOn)}
        </span>
      </span>
      <br />
      <span className="refreshed-key">
        {REPORTING_CONSTANTS.REFRESHED}
        &nbsp;
        <span className="refreshed-value">{refreshFrequency}</span>
      </span>
    </div>
  ) : (
    <></>
  );
};

export default RefreshInfoCard;
